// extracted by mini-css-extract-plugin
export default {"Body":"blogs_Body__e+3WN","Content":"blogs_Content__c8aJx","Blog":"blogs_Blog__ZNiJu","BlogMainHeader":"blogs_BlogMainHeader__dCc+f","BlogMainContent":"blogs_BlogMainContent__3WMQf"};